import { ActionType } from '../constants/ActionTypes';
import { Constants } from '../constants/Constants';
import { RestPath } from '../constants/SitePaths'
import config from '../constants/Configs';
import axios from 'axios';
import { message } from 'antd';

// Get SignUps
export const getSignUpsBegin = () => ({
    type: ActionType.GET_SIGNUPS_BEGIN
});

export const getSignUpsSuccess = (data) => ({
    type: ActionType.GET_SIGNUPS_SUCCESS,
    payload: data
});

export const getSignUpsError = (data) => ({
    type: ActionType.GET_SIGNUPS_ERROR,
    payload: data
});

// Delete SignUps
export const deleteSignUpsBegin = () => ({
    type: ActionType.DELETE_SIGNUPS_BEGIN
});

export const deleteSignUpsSuccess = (data) => ({
    type: ActionType.DELETE_SIGNUPS_SUCCESS,
    payload: data
});

export const deleteSignUpsError = (data) => ({
    type: ActionType.DELETE_SIGNUPS_ERROR,
    payload: data
});

export function getSignUps(mainPartnerId, pageNumber) {
    return dispatch => {
        dispatch(getSignUpsBegin());

        const params = {
            pageNumber,
            mainPartnerId
        };

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_SIGN_UPS,
            params: params
        }).then((response) => {
            dispatch(getSignUpsSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getSignUpsError(error));
            });
    }
}

export function deleteSignUps(id, intl) {
    return dispatch => {
        dispatch(deleteSignUpsBegin());
        const params = `?id=${id}`;

        return axios({
            method: Constants.DELETE,
            url: config.BASE_URL + RestPath.DELETE_SIGN_UPS + params,

        }).then((response) => {
            dispatch(deleteSignUpsSuccess(response.data));
            message.success(intl.messages.delete_user);
            return response.data;
        })
            .catch((error) => {
                dispatch(deleteSignUpsError(error));
            });
    }
}


// WEBPACK FOOTER //
// ./src/actions/SignUpsAction.js